import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CorService {

  constructor() { }


  getCores(): string[]{

    let cores: string[] = [];

    cores.push('rgb(255,255,255)');
    cores.push('rgb(250,204,204)');
    cores.push('rgb(255,235,204)');
    cores.push('rgb(255,255,204)');
    cores.push('rgb(204,232,204)');
    cores.push('rgb(204,224,245)');
    cores.push('rgb(235,214,255)');
    
    
    cores.push('rgb(187,187,187)');
    cores.push('rgb(240,102,102)');
    cores.push('rgb(255,194,102)');
    cores.push('rgb(255,255,102)');
    cores.push('rgb(102,185,102)');
    cores.push('rgb(102,163,224)');
    cores.push('rgb(194,133,255)');
    
    
    cores.push('rgb(136,136,136)');
    cores.push('rgb(230,0,0)'); 
    cores.push('rgb(255,153,0)');
    cores.push('rgb(255,255,0)');
    cores.push('rgb(0,138,0)');
    cores.push('rgb(0,102,204)');
    cores.push('rgb(153,51,255)');
    
    
    cores.push('rgb(68,68,68)');
    cores.push('rgb(102,0,34)');
    cores.push('rgb(178,107,0)');
    cores.push('rgb(178,178,0)');
    cores.push('rgb(0,97,0)');
    cores.push('rgb(0,71,178)');
    cores.push('rgb(107,36,178)');

    cores.push('rgb(0,0,0)'); 
    cores.push('rgb(92,0,0)');
    cores.push('rgb(102,61,0)');
    cores.push('rgb(102,102,0)');
    cores.push('rgb(0,55,0)');
    cores.push('rgb(0,41,102)');
    cores.push('rgb(61,20,102)');


    return cores;

  }
}
